export default [
  [0.1, 0.125, 0.145, 0.175, 0.185, 0.2],
  [0.15, 0.2, 0.25, 0.3, 0.35, 0.4],
  [0.175, 0.2, 0.275, 0.325, 0.35, 0.45],
  [0.2, 0.25, 0.3, 0.375, 0.4, 0.5],
  [99.0, 99.0, 99.0, 99.0, 99.0, 99.0],
  [0.3, 0.35, 0.4, 0.45, 0.5, 0.7],
  [99.0, 99.0, 99.0, 99.0, 99.0, 99.0],
] as const;
